// extracted by mini-css-extract-plugin
export default {"adminCalculatorWrapper":"Calculator_adminCalculatorWrapper__ErBIA"};